export const getAssignedClientRoleIds = (roles = [], clientRoles = [], clientId) => {
  if (!Array.isArray(roles) || !Array.isArray(clientRoles)) return [];

  const validRoleIds = new Set(clientRoles.map(({ id }) => String(id)));
  const rolePairs = roles.filter((role) => Array.isArray(role) && role.length === 2);

  if (rolePairs.length > 0) {
    return rolePairs
      .filter(([assignedClientId]) => String(assignedClientId) === String(clientId))
      .map(([, roleId]) => roleId)
      .filter((roleId) => validRoleIds.has(String(roleId)));
  }

  return roles.filter(
    (roleId) => !Array.isArray(roleId) && validRoleIds.has(String(roleId))
  );
};
